import React from "react";
import { Form, Input, InputNumber, Select } from "antd";
import { financialYearData } from "../../../../data";

function SchemeDetails({ dataScheme, crops, isEdit, handleSchemeChange }) {
  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">
        Scheme Details
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="schemeId"
          label={"Scheme Name"}
          rules={[
            {
              required: true,
              message: "Please select scheme",
            },
          ]}
        >
          <Select
            disabled={isEdit}
            allowClear
            placeholder="Select scheme"
            style={{
              width: "100%",
            }}
            options={
              dataScheme?.length > 0 &&
              dataScheme?.map((item) => ({
                value: item?.schId,
                label: item?.schName,
              }))
            }
            onChange={handleSchemeChange}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item name="countyName" label={"County"}>
          <Input disabled placeholder="Auto-filled" className="input" />
        </Form.Item> <Form.Item
          name="potentialAcreage"
          label={"Potential Acreage (Acres)"}
        >
          <InputNumber
            disabled
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Auto-filled"
            className="input flex"
          />
        </Form.Item>
       

        <Form.Item name="developedArea" label={"Developed Area (Acres)"}>
          <InputNumber
          disabled
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Auto-filled"
            className="input flex"
          />
        </Form.Item>
        <Form.Item name="irrigatedArea" label={"Irrigated Area (Acres)"}>
          <InputNumber  disabled
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Auto-filled"
            className="input flex"
          />
        </Form.Item> <Form.Item name="commandArea" label={"Total Command Area (Acres)"}>
          <InputNumber
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
        <Form.Item
          name="financialYear"
          label={"Financial Year"}
          rules={[
            {
              required: true,
              message: "Please select financial year",
            },
          ]}
        >
          <Select
            disabled={isEdit}
            allowClear
            placeholder="Select financial year"
            style={{
              width: "100%",
            }}
            options={financialYearData}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="cropId"
          label={"Crop"}
          rules={[
            {
              required: true,
              message: "Please select crop",
            },
          ]}
        >
          <Select
            disabled={isEdit}
            allowClear
            placeholder="Select crop"
            style={{
              width: "100%",
            }}
            options={
              crops?.length > 0 &&
              crops?.map((item) => ({
                value: item?.cropId,
                label: item?.cropName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
       
        <Form.Item name="farmersNumber" label={"No. of Farmers"}>
          <InputNumber
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>
      </div>
    </>
  );
}

export default SchemeDetails;
